import * as React from 'react';

export interface BadgeProps {
  text: string;
  type: string;
  className?: string;
  style?: object;
}
export const Badge: React.SFC<BadgeProps> = props => {
  return (
    <span className={'badge badge-pill badge-' + props.type + ' ' + props.className} style={props.style}>
      {props.text}
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/common/components/Badge.tsx